import { useQuery } from '@apollo/client';
import type { QueryHookOptions, QueryResult } from '@apollo/client';
import type { GetMeQuery, GetMeQueryVariables } from 'generated/graphql';
import { UserAnalytics } from 'modules/analytics/analytics';
import { GET_ME } from 'modules/Apollo/queries';
import { WithApolloContext } from 'modules/Apollo/types';
import { useMemo } from 'react';

export function useCurrentUser(
  options?: QueryHookOptions<GetMeQuery, GetMeQueryVariables>
): QueryResult<GetMeQuery, GetMeQueryVariables> {
  return useQuery<GetMeQuery, GetMeQueryVariables>(GET_ME, options);
}

export function useUserAnalytics({ context }: WithApolloContext): UserAnalytics | null {
  const { data } = useCurrentUser({ context });

  return useMemo(() => {
    if (data == null) return null;

    const {
      me: { id, firstName, lastName, email, clinic },
    } = data;

    return {
      id: id,
      email: email,
      name: `${firstName} ${lastName}`,
      clinicName: clinic?.name ?? 'no clinic',
      clinicSmid: clinic?.smid ?? 'no clinic',
    };
  }, [data]);
}
